import { render, staticRenderFns } from "./ClientsWorkgroups.vue?vue&type=template&id=74369bb6&"
import script from "./ClientsWorkgroups.vue?vue&type=script&lang=js&"
export * from "./ClientsWorkgroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports